import { AxiosResponse } from "axios";
import { getRequest, postRequest } from "../../utils/httpRequest";
import { RoryQuote } from "./types";

export const fetchQuotes = () =>
  (getRequest("/api/rory-quotes.json") as Promise<AxiosResponse<RoryQuote[]>>).then((r) => r.data);

export const fetchTopQuotes = () =>
  (getRequest("/api/rory-quotes/top.json") as Promise<AxiosResponse<RoryQuote[]>>).then((r) => r.data);

export const fetchQuote = (slug: string) =>
  (getRequest(`/api/rory-quotes/${slug}.json`) as Promise<AxiosResponse<RoryQuote>>).then((r) => r.data);

export const voteForQuote = (id: number) =>
  (postRequest(`/api/rory-quotes/${id}/vote.json`, {}) as Promise<AxiosResponse<{ votes: number }>>).then(
    (r) => r.data.votes,
  );

export const subscribeToWeeklyQuote = (email: string, firstName: string, honeypot: string, recaptchaToken: string) =>
  (postRequest("/api/rory-quotes/subscribe.json", {
    email,
    first_name: firstName,
    username: honeypot,
    recaptcha_token: recaptchaToken,
  }) as Promise<AxiosResponse<{ email: string }>>).then((r) => r.data);

export interface MatchResult {
  quote: RoryQuote;
  reason: string;
  ai: boolean;
}

export const matchQuote = (brief: string) =>
  (postRequest("/api/rory-quotes/match.json", { brief }) as Promise<AxiosResponse<MatchResult>>).then(
    (r) => r.data,
  );
